module.exports = __webpack_public_path__ + "assets/41677d193e7eb703307926d85235612b.mp3";